import { DataCache, DataCacheCollection, SharedKeyRelationship } from 'lib/DataCache';
import { MorePage } from 'data/models/MorePage';
import { PilotsMorePage } from 'data/models/PilotsMorePage';

import { PCCollection } from 'data/PCCache';

export class MorePageCache extends DataCache {
    MorePages       = PCCollection(MorePage);
    PilotsMorePages = PCCollection(PilotsMorePage);

    constructor() {
        super();

        new SharedKeyRelationship(this.PilotsMorePages, this.MorePages, p => p.MorePage, m => m.Pilots);
    }
}


// WEBPACK FOOTER //
// ./apps/portcall/morepage/cache.ts